import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function formatApiErrorDetail(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export const gbp = (n, dp = 2) =>
    "£" + Math.abs(Number(n || 0)).toLocaleString("en-GB", { minimumFractionDigits: dp, maximumFractionDigits: dp });

export const signedGbp = (n) => (n > 0 ? "+" : n < 0 ? "−" : "") + gbp(n, 0);

export const CATEGORY_COLORS = {
    "Groceries": "#10B981", "Eating Out": "#F59E0B", "Takeaways": "#FB923C", "Amazon & Online Shopping": "#FF9900",
    "Shopping": "#E879F9", "Subscriptions": "#8B5CF6", "Utilities": "#38BDF8", "Insurance": "#0EA5E9",
    "Mobile & Broadband": "#22D3EE", "Fuel": "#F87171", "Transport": "#EC4899", "Finance Payments": "#64748B",
    "Rent & Mortgage": "#94A3B8", "Council Tax": "#A3A3A3", "Health & Fitness": "#34D399", "Entertainment": "#A78BFA",
    "Kids & Family": "#FBBF24", "Cash": "#D4D4D8", "Transfers & Savings": "#2DD4BF", "Income": "#4ADE80", "Other": "#71717A",
};
export const catColor = (c) => CATEGORY_COLORS[c] || "#71717A";

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short" }) : "");
export const fmtDateFull = (iso) => (iso ? new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "—");

export async function streamChat(sessionId, message, onDelta) {
    const res = await fetch(`${API}/chat/sessions/${sessionId}/messages`, {
        method: "POST", credentials: "include", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ message }),
    });
    if (!res.ok) {
        let detail = "Chat failed";
        try { detail = formatApiErrorDetail((await res.json()).detail); } catch (_) {}
        const err = new Error(detail); err.status = res.status; throw err;
    }
    const reader = res.body.getReader();
    const dec = new TextDecoder();
    let buf = "";
    while (true) {
        const { value, done } = await reader.read();
        if (done) break;
        buf += dec.decode(value, { stream: true });
        const parts = buf.split("\n\n");
        buf = parts.pop();
        for (const p of parts) {
            const line = p.trim();
            if (!line.startsWith("data:")) continue;
            const payload = line.slice(5).trim();
            if (payload === "[DONE]") return;
            try {
                const j = JSON.parse(payload);
                if (j.delta) onDelta(j.delta);
                if (j.error) throw new Error(j.error);
            } catch (e) { if (e.message && !e.message.includes("JSON")) throw e; }
        }
    }
}
